/* The cross-store selector must describe this document after history restoration. */
(() => {
  if (window.isunStoreSelectorResetBound) return;
  window.isunStoreSelectorResetBound = true;
  const reset = (root = document) => {
    root.querySelectorAll('[data-isun-store-selector]').forEach((select) => {
      select.value = select.dataset.currentStore;
    });
  };
  window.addEventListener('pageshow', () => {
    reset();
    // Some browsers restore form values at the end of the history traversal.
    requestAnimationFrame(() => reset());
  });
  document.addEventListener('shopify:section:load', (event) => reset(event.target));
  reset();
})();
